import logoGroup from "../assets/group.png";

const NavbarComponent = () => {
  return (
    <div className="navbar-container">
      <img src={logoGroup} className="App-logo" alt="logo-kabita-group" style={{ width: 270 }} />
    </div>
  );
};

export default NavbarComponent;
